@if (showPreviewLabel()) {
    <h6 class="mb-2">{{'PREVIEW_AND_SUBMIT' | translate}}</h6>
}

<div class="stepper-layout">
    @if (showSearch()) {
        <div class="nav-item search">
            @if (showDropdown()) {
                <div class="mr-2">
                    <p-select appendTo="body" [options]="dropdownOptions()" optionLabel="label" placeholder="Select" (onChange)="onOptionChange($event)" appendTo="body"/>
                </div>
            }

            <div class="search">
                <input [id]="'search'" [name]="'search'" pInputText type="text" placeholder="Search" [(ngModel)]="searchValue" (keydown.enter)="onSearchInput()" (ngModelChange)="onSearchChange($event)"/>
                <i class="icon search-icon"></i>

                @if(searchValue && searchValue.length > 0) {
                    <i class="icon close-icon" (click)="clearSearch()"></i>
                }
            </div>
            <!-- <div class="nav-item search">
                <input pInputText type="text" placeholder="{{'SEARCH' | translate}}"
                    [(ngModel)]="searchValue" (input)="onSearchInput($event)"
                    (keydown.enter)="onSearchInput($event)" />

                @if(searchValue && searchValue.length > 0) {
                    <i class="icon close-icon" (click)="clearSearch()"></i>
                }

                <i class="icon search-icon"></i>
            </div> -->
        </div>
    }
    <div class="stepper">
        <div class="step">
            <ul class="stepper-list">
                @if(selected?.value > 0){
                    <li class="mb-1">
                        <p-checkbox binary="true" inputId="selectAll" name="selectAll" [(ngModel)]="selectAll" (onChange)="onSelectAllChange()" class="me-3"/>
                        <label for="ny">{{'SELECT_ALL' | translate}}</label>
                    </li>
                }
                @for (step of steps(); track $index) {
                    <app-preview-node [node]="step" [hasExpandableNodes]="hasExpandableNodes()" [selectedStep]="selectedStep" 
                    [showCheckbox]="showCheckbox" (onStepClickEvent)="onStepClick($event)" [isFirstLayer]="true"/>
                }
            </ul>
        </div>
    </div>
</div>

<div class="footer">
    @if(showActionBtns) {
        <div class="btn-container">
            <app-button type="secondary" label="Cancel" (click)="onCancel()" [disable]="isLoading"></app-button>
            <app-button type="primary" label="Confirm" (click)="onConfirm()"
            [bypassPermCheck]="true" [disable]="isLoading" [showSpinner]="isLoading"></app-button>
        </div>
    }
</div>